/**
 * Plugin
 */

import Util from '../../Util';

class Plugin {
  public onAdded: any;

  public onFailed: any;

  private page: string;

  private type: string;

  private url: string;

  private options: any;

  constructor( page: string = '', type: string = '', options?: any ) {
    if ( page === '' || type === '' ) {
      return;
    }

    const win = window as any;

    this.page = this.capitalizeFirstLetter( page );
    this.type = this.capitalizeFirstLetter( type );
    this.options = options;
    this.url = '';

    const staticInfo = this.getStaticUrl();

    switch ( this.type ) {
      case 'Vote':
      this.url = `${staticInfo.url}/uikit/nccommunity-vote/js/vote${staticInfo.net}.js`;
      break;

      default:
      this.url = `${staticInfo.url}/uikit/nccommunity-vote/js/vote${staticInfo.net}.js`;
    }

    this.onAdded = new Util.Observer();
    this.onAdded.add( () => {
      const plugin = new win.ui.ncCommunity[ this.type ][ this.page ]( this.options );
    }, this);

    this.onFailed = new Util.Observer();
    this.onFailed.add( () => {
      // onFailed
    }, this);
  }

  public addPlugin() {
    this.loadFile( this.url );
  }

  private loadFile( url: string ) {
    const fileRef = document.createElement( 'script' );
    fileRef.setAttribute( 'src', url );
    fileRef.setAttribute( 'type', 'text/javascript' );
    fileRef.onload = () => { this.onAdded.emit(); };
    fileRef.onerror = ( evt ) => { this.onFailed.emit(); };
    document.getElementsByTagName( 'head' )[ 0 ].appendChild( fileRef );
  }

  private capitalizeFirstLetter( str: string ) {
    return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
  }

  private getStaticUrl() {
    const win = window as any;
    let serviceEnv = win._serviceEnv || 'live';
    let url = '';
    let net = '.dev';

    serviceEnv = serviceEnv.toLowerCase();

    switch ( serviceEnv ) {
      case 'opdev':
        url = 'http://ui-static.korea.ncsoft.corp';
        break;
      case 'sb':
        url = 'https://sb-wstatic.plaync.com';
        break;
      case 'rc':
        url = 'https://rc-wstatic.plaync.co.kr';
        break;
      default:
        url = 'https://wstatic-cdn.plaync.com';
        net = '';
    }

    return { url, net };
  }
}

export default Plugin;
